"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineActions;
exports.ACTION_TYPE_DELIMITER = void 0;
var ACTION_TYPE_DELIMITER = '||';
exports.ACTION_TYPE_DELIMITER = ACTION_TYPE_DELIMITER;

function combineActions() {
  for (var _len = arguments.length, actionTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    actionTypes[_key] = arguments[_key];
  }

  return actionTypes.join(ACTION_TYPE_DELIMITER);
}